import { wccModules } from "enums/wccModules";
import { inject, injectable } from "inversify";
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';
import UserContentFormVM from "./base";
import { UserContentFormConfig } from "./base.interfaces";
import './inline.html';
import './inline.scss';

components.preload('vote-bubble');

export interface InlineUserContentFormConfig extends UserContentFormConfig {
    vote: SubscribableOrNullableValue<number>
    compact?: SubscribableOrNullableValue<boolean>
    ready: SubscribableOrNullableValue<boolean>
    busy: SubscribableOrNullableValue<boolean>
}

@injectable()
export default class InlineUserContentFormVM extends UserContentFormVM {
    labels = labels

    infoNodes: Array<Node>
    bodyNodes: Array<Node>
    footerNodes: Array<Node>

    vote: Subscribable<number | undefined>

    isReady: Subscribable<boolean>
    isBusy: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: InlineUserContentFormConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        super(config, storage);

        this.vote = ko.flattenComputed(config.vote);

        this.infoNodes = $(info.templateNodes).filter('form-info').contents().toArray() as Array<Node>;
        this.bodyNodes = $(info.templateNodes).filter('form-body').contents().toArray() as Array<Node>;
        this.footerNodes = $(info.templateNodes).filter('form-footer').contents().toArray() as Array<Node>;

        const isCompact = ko.flattenComputed(config.compact, false);

        const isModerator = this.person.pluck('isModerator', false);
        const isObserver = this.person.pluck('isObserver', false);

        this.isReady = ko.flattenComputed(config.ready, true);
        this.isBusy = ko.flattenComputed(config.busy, false);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'topic-usercontent-inline': true,
                'topic-usercontent-inline--classic': isCompact.not(),
                'topic-usercontent-inline--compact': isCompact,
                'topic-usercontent-inline--moderator': isModerator,
                'topic-usercontent-inline--observer': isObserver
            }
        }, this);
    }
}